<template>
    <div class="registered">
        <div class="mymain-login">
            <div class="table">
                <div class="imgDiv">
                    <img src="@/assets/images/login1.png" alt=""> 
                </div>
                <el-form :model="datas" :rules="rules" ref="datas" class="fromdiv">
                    <p>找回密码</p>
                    <div class="fromitem">
                        <!-- 请输入手机号 -->
                        <el-form-item prop="username">
                            <el-input v-model="datas.username" @keyup.enter.native="clickRorgetPassword" :placeholder="$store.state.lang.inputPhone" clearable></el-input>
                        </el-form-item>
                        <!-- 请输入验证码 -->
                        <el-form-item prop="verifycode" class="verifycodediv">
                            <el-input v-model="datas.verifycode" :placeholder="$store.state.lang.inputCode" class="inputcode" clearable></el-input>
                            <div class="imgdiv" @click="getCode">
                                <img :src="imgsrc" alt="">
                            </div>
                        </el-form-item> 
                        <!-- 请输入短信验证码 -->
                        <el-form-item prop="code">
                            <el-input v-model="datas.code" @keyup.enter.native="clickRorgetPassword" :placeholder="$store.state.lang.inputCode" class="inputcode" clearable></el-input>
                            <input type="button" class="code" v-model="codeMsg" @click="clickCode" :disabled="codeDisabled" />
                        </el-form-item>                               
                        <!-- 请输入密码 -->
                        <el-form-item prop="password">
                            <el-input type="password" v-model="datas.password" @keyup.enter.native="clickRorgetPassword" :placeholder="$store.state.lang.inputPsword" autocomplete="off" clearable></el-input>
                        </el-form-item>
                        <el-button type="primary" :loading="btnloading" @click="clickRorgetPassword('datas')">{{$store.state.lang.submit}}</el-button>
                    </div>
              </el-form>
            </div>
        </div>
    </div>
</template> 

<script>
import api from "@/api/setPassword.js";
import store from "@/vuex/store";
let Base64 = require('js-base64').Base64;
    export default {
        data() {
            // 验证规则
            var validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$store.state.lang.inputPhone));
                } else {
                    //验证手机号码                   
                    let reg=11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
                    if(!reg.test(value)){
                        callback(new Error(this.$store.state.lang.point1));    
                    }else{
                        this.showname = true;
                        callback();
                    }
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$store.state.lang.inputPsword));
                } else {
                    //验证密码，长度6-30位，数字和字母组合 
                    let regpass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,30}$/;
                    if(!regpass.test(value)){
                        callback(new Error(this.$store.state.lang.enterdigits)); //请输入6到30位,数字和字母组合的密码
                    }else{
                        callback();
                    }
                }
            };
            // 短信验证码
            var validateCode = (rule, value, callback) => {
                if (value.replace(/(^\s+)|(\s+$)/g,"") === '') {
                    callback(new Error(this.$store.state.lang.inputCode));
                } else {
                    callback();
                }
            };
            var validateVerifycode = (rule, value, callback) => {
                if (value.replace(/(^\s+)|(\s+$)/g,"") === '') {
                    callback(new Error(this.$store.state.lang.inputCode));
                } else {     
                    let reg = /^[A-Za-z0-9]{1,6}$/;      //正则匹配：英文大小写，数字
                    if(!reg.test(value)){
                        callback(new Error(this.$store.state.lang.inputCode2));    //请输入正确的验证码
                        return false
                    }                
                    callback();
                }
            };
            return {
                datas:{  
                    username: '',   
                    password: '',
                    code: '',
                    verifycode: ''                          
                },
                codeDisabled: false,      // 是否禁用按钮  
                countdown: 60,            // 倒计时秒数
                codeMsg: '获取验证码',              // 按钮上的文字
                timer: null,              // 定时器    
                btnloading: false,      
                rules: {                  //验证
                    username: [
                        { required: true, validator: validateName, trigger: 'blur' }
                    ],
                    verifycode: [
                        { required: true, validator: validateVerifycode, trigger: 'blur' }
                    ],
                    code: [
                        { required: true, validator: validateCode, trigger: 'blur' }
                    ],
                    password: [
                        { required: true, validator: validatePass, trigger: 'blur' }
                    ]
                },
                showname: false,
                imgsrc: ''                       
            }
        },
        store,
        created(){
            this.getCode();
        }, 
        methods:{
            // 验证码
            clickCode(){               
              //获取验证码的请求
               //获取验证码的请求  
              if(this.showname==false || this.datas.verifycode==''){
                this.$message.error(this.$store.state.lang.inputPhonea); 
                return false
              }
              api.getcode(this.datas).then(Response=>{
                    //console.log(Response)
                    this.$message(this.$store.state.lang.sentCode); 
                    // 验证码60秒倒计时
                    if(!this.timer) {
                        this.timer = setInterval(() => {
                            if (this.countdown > 0 && this.countdown <= 60) {
                                this.countdown--;
                                if (this.countdown != 0) {
                                    this.codeMsg = this.countdown + "s后再获取";
                                    this.codeDisabled = true;
                                } else {
                                    clearInterval(this.timer);
                                    this.codeMsg = '获取验证码';
                                    this.countdown = 60;
                                    this.timer = null;
                                    this.codeDisabled = false;
                                }
                            }
                        }, 1000)            
                    }                                      
                }).catch(error=>{
                    //console.log(error)
                    this.getCode();
                })
            },
            // 找回密码
            clickRorgetPassword(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.btnloading = true;
                        api.forgetPassword(this.datas).then(Response=>{
                            //console.log(Response)
                            this.$message.success(this.$store.state.lang.passwordSuccessful);  
                            setTimeout(() => {                    
                                this.$router.push('/')
                            }, 2000);
                        }).catch(error=>{
                            //console.log(error)
                            this.btnloading = false;
                        })
                    } else {
                        //console.log('error submit!!');
                        return false;
                    }
                });                    
            },
            // 获取验证码
            getCode(){
                // this.imgsrc = "http://36.112.128.100:8890/ticketAppUser/getVerifyCode?"+Math.random();
                this.imgsrc = "https://pay.horti-expo2019.com:8890/ticketAppUser/getVerifyCode?"+Math.random();
            }
        },
        watch: {
          // 如果路由有变化，会再次执行该方法
          "$route": "routeNew"
        }
    }
</script>

<style lang="stylus" scoped>
.registered {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  .mymain-login {
    width: 100%;
    height: 100%;
    margin: auto;
    background: url(../assets/images/loginbg.png) center no-repeat;
    background-size: cover;
    position: relative;
    .table {
        width: 468px;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        .imgDiv{
            width: 468px;
            margin: auto;  
            padding-bottom: 40px;     
            img {
                display: inline-block;
                max-width: 100%;
                max-height: 100%;
            }
        }
        .fromdiv{
            margin: 0 50px;
            background-color: rgba(255,255,255,0.3);
            border-radius: 6px;
            padding: 14px 0 0 0;
            text-align: center;
            p{
                color: #fff;
                letter-spacing: 1px;
            }
            .fromitem{
                padding: 25px 25px 20px 25px;
                .iconfont{
                    font-size: 20px;
                    display: inline-block;
                    color: #38608F;
                }
                .code{
                    float: left;
                    width: 143px;
                    padding: 1px 0;
                    height: 36px;
                    color: inherit;
                    background: #f4f4f5;
                    display: inline-block;
                    border: none;
                    border-left: 0;
                    border-radius: 0 36px 36px 0;
                    cursor: pointer;
                    color: #909399;
                }
                .code:hover{
                    background: #909399;
                    color: #fff;
                }
                .verifycodediv{
                    .imgdiv{
                        width: 143px;
                        height: 36px;
                        float: left;
                        img{
                            width: 100%;
                            height: 100%;
                            display: inline-block;
                            border-radius: 0 36px 36px 0;
                        }
                    }
                }
            }
            .el-button{
                width: 100%;
                background-color: #16365C;
                border: none;
                font-size: 16px;
                margin-top: 9px;
                border-radius: 40px;
            }
        }
    }
  } 
}


</style>
<style>
.registered .el-input__inner,
.registered .el-form-item__content {
    height: 36px;
    line-height: 36px;
    border-radius: 36px!important; 
}
.registered .el-input__prefix{
    left: 18px!important;
}
.registered .inputcode{
    width: 175px;
    float: left;
}
.login .el-input__inner{
    padding-left: 50px!important;
}
.registered .inputcode .el-input__inner{
    border-radius: 36px 0 0 36px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/SetPassword.vue